import React, { useState, useEffect } from 'react'
import Breadcrumb from '../breadcrumb/breadcrumb.component'
import { Formik } from 'formik'
import Yup from '../../../../helpers/custom-yup'
import Conclusion from './conclusion.component'
import Topo from '../topo/topo.component'
import DocumentRG from './document-rg.component'
import DocumentCPF from './document-cpf.component'
import DocumentUsername from './document-username.component'
import DocumentBirthDate from './document-birthdate.component'
import Phone from './phone.component'
import { AuthenticationService } from '../../../../services'
import { history } from '@helpers'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { toastActions } from '../../../../actions'
import { routes } from '../../../../constants'

const Main = props => {
	const [rg, setRg] = useState('')
	const [cpf, setCpf] = useState('')
	const [step, setStep] = useState(1)
	const [phone, setPhone] = useState('')
	const [username, setUsername] = useState('')
	const [birthDate, setBirthDate] = useState('')
	const [shouldCreateUser, setShouldCreateUser] = useState(false)
	const {
		hideLoading,
		showLoading,
		providerSignupData,
		userLogin,
		toastError
	} = props

	function handleSetCpf(value) {
		setCpf(value)
	}

	function handleSetPhone(value) {
		setPhone(value)
	}

	function handleSetRg(value) {
		setRg(value)
	}

	function handleSetName(value) {
		setUsername(value)
	}

	function handleSetBirthDate(value) {
		setBirthDate(value)
	}

	function nextStep() {
		if (step < 6) setStep(step + 1)
	}

	function prevStep() {
		if (step > 0) {
			setStep(step - 1)
		}
	}

	const schema = Yup.object().shape({
		cpf: Yup.string()
			.required('Informe o CPF')
			.cpf()
			.nullable()
	})

	const initialValues = {
		rg: '',
		cpf: '',
		phone: '',
		username: providerSignupData ? providerSignupData.name : '',
		birthDate: ''
	}

	useEffect(() => {
		if (shouldCreateUser && rg && cpf && phone && providerSignupData) {
			setShouldCreateUser(false)
			showLoading()

			const obj = {
				rg,
				phone,
				cpf,
				email: providerSignupData.email,
				name: username,
				birthday: birthDate
			}

			AuthenticationService.loginSocialClientRegister(obj)
				.then(data => {
					if (!data.success) {
						toastError({
							message: 'Não foi possível concluir o cadastro.'
						})
						history.push(routes.ENTRAR)
						hideLoading()
						return
					}
					userLogin(data.data)
					hideLoading()
				})
				.catch(() => {
					toastError({
						message: 'Erro de conexão. Tente novamente.'
					})
					hideLoading()
				})
		}
	}, [shouldCreateUser, rg, cpf, phone, providerSignupData])

	return providerSignupData ? (
		<section>
			<Topo step={step} name={username} />
			<Breadcrumb step={step} />
			<Formik
				validationSchema={schema}
				initialValues={initialValues}
				onSubmit={action => {
					action.resetForm()
				}}>
				{props => (
					<form onSubmit={props.handleSubmit} autoComplete="off">
						{step === 1 && (
							<DocumentCPF
								{...props}
								nextStep={nextStep}
								showLoading={showLoading}
								hideLoading={hideLoading}
								handleSetCpf={handleSetCpf}
								providerSignupData={providerSignupData}
							/>
						)}
						{step === 2 && (
							<DocumentRG
								{...props}
								nextStep={nextStep}
								prevStep={prevStep}
								showLoading={showLoading}
								hideLoading={hideLoading}
								handleSetRg={handleSetRg}
								providerSignupData={providerSignupData}
								toastError={toastError}
							/>
						)}
						{step === 3 && (
							<DocumentUsername
								{...props}
								nextStep={nextStep}
								prevStep={prevStep}
								handleSetUsername={handleSetName}
								providerSignupData={providerSignupData}
							/>
						)}
						{step === 4 && (
							<DocumentBirthDate
								{...props}
								nextStep={nextStep}
								prevStep={prevStep}
								handleSetBirthDate={handleSetBirthDate}
							/>
						)}
						{step === 5 && (
							<Phone
								{...props}
								nextStep={() => {
									setShouldCreateUser(true)
									nextStep()
								}}
								prevStep={prevStep}
								handleSetPhone={handleSetPhone}
							/>
						)}
						{step === 6 && (
							<Conclusion
								{...props}
								providerSignupData={providerSignupData}
							/>
						)}
					</form>
				)}
			</Formik>
		</section>
	) : null
}

const mapDispatchToProps = {
	toastError: toastActions.danger
}

const connectedMainComponent = withRouter(
	connect(null, mapDispatchToProps)(Main)
)

export default connectedMainComponent
